window.addEventListener('load',function(){
      var maxHeight = 0;
      $(".card_swacthes-custom").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
      });
      $(".card_swacthes-custom").height(maxHeight);
    });

    $(document).ready(function(){

      $('#FacetsWrapperDesktop .facets__disclosure-vertical:eq(0) summary.facets__summary').trigger('click');
      
      $('.dropdown-menu-item').mouseenter(function(){
        $(this).parent('details').attr('open','open');
        $('.js details > .header__submenu').css('opacity','1')
      });
      $('.header__submenu').mouseleave(function(){
        $(this).parent('details').removeAttr('open');
        $(this).css('opacity','0')
      });

      $(".spr-starrating").click(function() {
        $('html, body').animate({
          scrollTop: $(".product__accordion details.customer-reviews").offset().top -150
        }, 1000);
        $(".product__accordion details.customer-reviews").attr("open","")
      });    

      
    });  